import { Injectable, Inject } from '@angular/core';
import { HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig } from '../config/hotel-tours-list-page.config';
import { SearchService } from './search/search.service';

@Injectable({ providedIn: 'root' })
export class TourViewLinkService {
    constructor(
        @Inject(HOTEL_TOURS_PAGE_CONFIG) private config: HotelToursPageConfig,
        private searchService: SearchService,
    ) {}

    getHref(tour: { id: string; hotelId: number }): string {
        // параметры нужно для
        let url = this.config.tourViewUrl + tour.id;
        url += `&hotelId=${tour.hotelId}`;
        if (this.searchService.getLastSearchParams()) {
            url += `&dateFrom=${this.searchService.getLastSearchParams().dateFrom}`;
            url += `&dateTo=${this.searchService.getLastSearchParams().dateTo}`;
            url += `&daysFrom=${this.searchService.getLastSearchParams().nightsFrom + 1}`;
            url += `&daysTo=${this.searchService.getLastSearchParams().nightsTo + 1}`;

            if (this.searchService.getLastSearchParams().operators) {
                url += `&operators=${this.searchService.getLastSearchParams().operators.join(',')}`;
            }
            if (this.searchService.getLastSearchParams().airlines) {
                url += `&airlines=${this.searchService.getLastSearchParams().airlines.join(',')}`;
            }
        }

        return url.toString();
    
    }
}

